"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const __1 = require("../..");
const InputGroup_1 = __importDefault(require("./InputGroup"));
const NumberSelectField = (props) => {
    var _a, _b, _c, _d, _e;
    function handleAmountChange(event) {
        var _a, _b;
        if (props.onInput) {
            const amountParsed = parseInt(event.currentTarget.value, 10);
            props.onInput({
                amount: isNaN(amountParsed) ? '' : amountParsed,
                unit: (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.unit) !== null && _b !== void 0 ? _b : '',
            });
        }
    }
    function handleUnitChange(event) {
        var _a, _b;
        if (props.onInput) {
            props.onInput({
                amount: (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0,
                unit: event.currentTarget.value,
            });
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(InputGroup_1.default, null,
            React.createElement(__1.Input, { id: props.id, type: "number", name: props.name + '[amount]', value: (_a = props.value) === null || _a === void 0 ? void 0 : _a.amount, onChange: handleAmountChange, placeholder: props.placeholder, disabled: (_b = props.disabled) !== null && _b !== void 0 ? _b : false, min: props.minAmount, max: props.maxAmount }),
            React.createElement(__1.Select, { options: props.unitOptions, name: props.name + '[unit]', value: typeof ((_c = props.value) === null || _c === void 0 ? void 0 : _c.unit) === 'string' ? (_d = props.value) === null || _d === void 0 ? void 0 : _d.unit : undefined, onChange: handleUnitChange, disabled: (_e = props.disabled) !== null && _e !== void 0 ? _e : false })),
        props.errorMessage &&
            React.createElement(__1.Message, { message: props.errorMessage, type: "error", form: true })));
};
exports.default = NumberSelectField;
//# sourceMappingURL=NumberSelectField.js.map